import React, { useEffect, useState } from "react";
import "../css/MenuStart.css";
import {
    Badge,
    Button,
    Divider,
    FormControl,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    List,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";

import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";
import SearchIcon from "@material-ui/icons/Search";
import Person from "../components/Person";
import { Link, Redirect, useLocation } from "react-router-dom";

import routes from "../../utils/routes.json";
import api from "../../utils/api";
import Echo from "laravel-echo";

const useStyles = makeStyles((theme) => ({
    fullWidth: {
        width: "100%",
    },
    maxWidth: {
        maxWidth: "500px",
    },
    blackElem: {
        backgroundColor: theme.palette.primary.main,
    },
    blackButton: {
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        "&:hover": {
            background: theme.palette.primary.main,
        },
    },
    marginButton: {
        margin: "20px 7%",
    },
    badge: {
        backgroundColor: "#FF5A00",
        borderRadius: "50%",
        color: "#fff",
    },
    bigBadge: {
        backgroundColor: "#FF5A00",
        borderRadius: "50%",
        color: "#fff",
        height: "30px",
        minWidth: "30px",
        fontSize: "20px",
    },
}));

type locationState = {
    categoryIds: string[],
}

export default function ChallengeOpponent(): JSX.Element {
    const { t } = useTranslation();
    const classes = useStyles();

    const location: locationState = useLocation<locationState>().state;

    if (!location)
        return <Redirect to={routes.categories} />;

    const [searchText, setSearchText] = useState('');

    const [friends, setFriends] = useState([]);
    const [filteredFriends, setFilteredFriends] = useState([]);
    

    useEffect(() => {
        api.get(
            routes.friendsList,
        )
            .then(response => {
                setFriends(response.data.data.FRIENDS);
            });
        //console.log(response);
        //setState(response);
    }, []);

    const handleInputChange = (event: { target: { value: any; }; }) => {
        const { value } = event.target;
        setSearchText(value);
    };


    const handleSearch = () => {
        const filteredPlayers = friends.filter((item: any) => item.username.toLowerCase().includes(searchText.toLowerCase()));
        setFilteredFriends(filteredPlayers);
    }

    const playerElements = (filteredFriends.length > 0 ? filteredFriends : friends).map((item: any) => <Person key={item.id} id={item.id} personName={item.username} path={"#"} />);

    return (
        <MainScreen lower={false} back={true}>
            <Paper style={{ overflow: "auto" }} elevation={0}>
                <Paper classes={{ root: classes.marginButton }}>
                    <Badge
                        badgeContent={"vs"}
                        anchorOrigin={{ vertical: "top", horizontal: "left" }}
                        classes={{ badge: classes.bigBadge, root: classes.fullWidth }}
                    >
                        <Link
                            to={{
                                pathname: routes.matchmaking, state: { categoryIds: location.categoryIds },
                            }}
                            className={`${classes.fullWidth}`}
                        >
                            <Button color="primary" classes={{ root: classes.blackButton }} style={{ color: "#2c3e50" }}>
                                <Typography variant="h2" color="secondary">
                                    {t("choose-opponent.random")}
                                </Typography>
                            </Button>
                        </Link>
                    </Badge>
                </Paper>
                <Typography variant="h6">
                    {t("choose-opponent.suggested")}
                </Typography>
                <Divider orientation="horizontal" classes={{ root: classes.blackElem }} />
                <List>
                    {playerElements}
                </List>
                <Typography variant="h6">
                    {t("choose-opponent.friends")}
                </Typography>
                <Divider orientation="horizontal" classes={{ root: classes.blackElem }} />

                <FormControl className={`${classes.fullWidth}  ${classes.maxWidth}`}>
                    <InputLabel htmlFor="standard-adornment-password" className={classes.fullWidth}>
                        {t("choose-opponent.name")}
                    </InputLabel>
                    <Input
                        id="standard-adornment-weight"
                        type="text"
                        value={searchText}
                        onChange={handleInputChange}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton aria-label="search" onClick={handleSearch}>
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        }
                        aria-describedby="standard-weight-helper-text"
                        inputProps={{
                            "aria-label": "weight",
                        }}
                    />
                </FormControl>
                <List>
                    {playerElements}
                </List>
            </Paper>
        </MainScreen>
    );
}
